import { CancelToken } from "axios";
import { authAxios as axios } from "shared-auth";

import config from "config/global";

import { IPhoto } from "models/api";

import { profileConverter } from "services/api/profile/profileService.converters";

export interface IProfilePhotoData {
  artistRef: string;
  forename: string;
  surname: string;
  mainPhoto: IPhoto;
  photos: IPhoto[];
}

export type GetPhotos = (cancellationToken?: CancelToken) => Promise<IPhoto[]>;

class ProfileService {
  private readonly url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public getPhotos: GetPhotos = async (cancellationToken) => {
    const response = await axios(
      `${this.url}/profiles/bulk?includeGalleryPhotos=true`,
      {
        method: "get",
        headers: {
          "X-Spotlight-Performer": "NONE",
        },
        cancelToken: cancellationToken,
      }
    );

    return profileConverter.convert(response.data);
  };
}

export default new ProfileService({
  url: config.facetsApiUrl,
});
